import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import FontAwesome from 'react-fontawesome';
import {EditorDialog} from '../editor-components';
import ExhibitorSelect from './exhibitor-select';

/** @class CreateAffiliateDialog
  * A component for creating a new affiliate.
  */
export default class CreateBoothDialog extends Component {
  /** @constructor
    * Constructs a new CreateAffiliateDialog instance
    */
  constructor(props) {
    super(props);
    this.state = {
      exhibitorID: '',
      name: '',
      contactName: '',
      contactEmail: '',
      contactPhone: ''
    }
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    console.log('handleChange', value, name);
    this.setState({
      [name]: value
    });
  }
  /** @function handleSave
    * Applies the current state to the database,
    * clears the form, and closes the dialog.
    */
  handleSave(event) {
    event.preventDefault();
    // Create booth
    firebase.database().ref(`/expos/${this.props.expoID}/shows/${this.props.showID}/booths`).push({
      metadata: {
        name: this.state.name,
        status: 'Unassigned'
      },
      halls: {},
      contents: {},
      exhibitorID: this.state.exhibitorID,
      contactName: this.state.contactName,
      contactEmail: this.state.contactEmail,
      contactPhone: this.state.contactPhone
    })
    // Add booth to exhibitor record (if set)
    .then((boothRef) => {
      if(this.state.exibitorID) {
        return firebase.database()
          .ref(`/exhibitors/${this.state.exhibitorID}/booths/${this.props.expoID}/${this.props.showID}/${boothRef.key}`)
          .set(this.state.name);
      } else {
        return Promise.resolve();
      }
    })
    // Reset state
    .then(()=>{
      this.setState({
        exhibitorID: '',
        name: '',
        contactName: '',
        contactEmail: '',
        contactPhone: ''
      });
      this.props.onExit();
    });
  }
  /** @method render
    * Renders the component
    */
  render() {
    const style={maxWidth: "80vw"}
    return (
      <EditorDialog show={this.props.show} onExit={this.props.onExit}>
        <h3>Add New Booth</h3>
        <ExhibitorSelect value={this.state.exhibitorID} onChange={this.handleChange}/>
        <form onSubmit={this.handleSave} style={style}>
          <div className="input-group">
            <label htmlFor="name">Booth Name</label>
            <input name="name" type="text"
              value={this.state.name}
              onChange={this.handleChange}/>
          </div>
          <div className="input-group">
            <label htmlFor="contactName">Booth Build Contact Name</label>
            <input name="contactName" type="text"
              value={this.state.contactName}
              onChange={this.handleChange}/>
          </div>
          <div className="input-group">
            <label htmlFor="email">Booth Build Contact Email</label>
            <input name="contactEmail" type="email"
              value={this.state.contactEmail}
              onChange={this.handleChange}
              />
          </div>
          <div className="input-group">
            <label htmlFor="contactPhone">Booth Build Contact Phone</label>
            <input name="contactPhone" type="text"
              value={this.state.contactPhone}
              onChange={this.handleChange}
              pattern="[0-9]{3}[ -][0-9]{3}[ -][0-9]{4}"
              />
          </div>
          <div className="button-group">
            <button type="submit" className="btn btn-success">
              <FontAwesome name="save"/>
              Save Booth
            </button>
          </div>
        </form>
      </EditorDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/booth-list/create-booth-dialog.js